import styled, { css } from 'styled-components';

import { floorGameDuration as duration, floorGameEasing as easing } from '@pkg/primitives';

interface StyledRadialGradientProps {
    $size: number;
    $x: number;
    $y: number;
    $primary: string;
    $secondary: string;
}

// This component uses CSS Houdini to declare custom properties as
// "animatable". Choosing this approach over framer-motion.
export const StyledRadialGradient = styled.div<StyledRadialGradientProps>`
    @property --size {
        inherits: false;
        initial-value: 0%;
        syntax: '<percentage>';
    }

    @property --x {
        inherits: false;
        initial-value: 0%;
        syntax: '<percentage>';
    }

    @property --y {
        inherits: false;
        initial-value: 0%;
        syntax: '<percentage>';
    }

    @property --primary {
        inherits: false;
        initial-value: #111;
        syntax: '<color>';
    }

    @property --secondary {
        inherits: false;
        initial-value: #000;
        syntax: '<color>';
    }

    ${({ $size, $x, $y, $primary, $secondary }) => css`
        --size: ${$size}%;
        --x: ${$x}%;
        --y: ${$y}%;
        --primary: ${$primary};
        --secondary: ${$secondary};
    `};

    width: 100%;
    height: 100%;
    background: radial-gradient(var(--size) var(--size) at var(--x) var(--y), var(--primary), var(--secondary));
    transition-property: --size, --x, --y, --primary, --secondary;
    transition-duration: ${duration.slow}ms;
    transition-timing-function: ${easing.cubic};
`;
